import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Draft from "./Draft";
import "./DraftBoard.css";
import API_URL from "./config";

const DraftBoard = () => {
  const navigate = useNavigate();
  const [saveData, setSaveData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSaveData = async () => {
      try {
        const saveId = localStorage.getItem("activeSaveId");
        const user = JSON.parse(localStorage.getItem("user") || "{}");

        if (!saveId || !user._id) {
          setError("No active save found");
          setLoading(false);
          return;
        }

        const res = await fetch(`${API_URL}/api/saves/${saveId}`, {
          headers: { "X-User-ID": user._id },
        });

        if (!res.ok) {
          setError("Failed to load save");
          setLoading(false);
          return;
        }

        const data = await res.json();
        setSaveData(data.save);
        setLoading(false);
      } catch (err) {
        setError(err.message || "Error loading save data");
        setLoading(false);
      }
    };

    fetchSaveData();
  }, []);

  if (loading) {
    return (
      <div className="draft-board-page">
        <Navbar />
        <div className="draft-board-container">
          <div className="draft-error-state">
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !saveData) {
    return (
      <div className="draft-board-page">
        <Navbar />
        <div className="draft-board-container">
          <div className="draft-error-state">
            <p>{error || "No active save found"}</p>
            <button onClick={() => navigate("/dashboard")} className="back-btn">
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="draft-board-page">
      <Navbar />
      <div className="draft-board-container">
        <Draft 
          saveId={localStorage.getItem("activeSaveId")} 
          teamId={saveData.teamId} 
          season={saveData.currentSeason} 
        />
      </div>
    </div>
  );
};

export default DraftBoard;
